import { Component, Input } from '@angular/core';

import { VBrickPlayerComponent } from 'vbrick-player-src/VbrickPlayer.Component';

import styles from './VgToggleChapterDisplayButton.module.less';

@Component({
	selector: 'vg-toggle-chapter-display-button',
	host: {
		'[class]': 'styles.root'
	},
	template: `
		<button
			type="button"
			[attr.aria-label]="vbrickPlayer.chapterHelper.showChapterImage ? translations.chapterImageShow : translations.chapterImageHide"
			[ngClass]="[
				styles.button,
				vbrickPlayer.chapterHelper.showChapterImage ? 'vb-icon-image' : 'vb-icon-image-none'
			]"
			[tooltip]="chapterToggleTooltip"
			[placement]="'top'"
			(click)="toggleChapterImage()">
		</button>
		<ng-template #chapterToggleTooltip>
			{{ vbrickPlayer.chapterHelper.showChapterImage ? translations.chapterImageShow : translations.chapterImageHide }}
		</ng-template>
	`,
    standalone: false
})
export class VgToggleChapterDisplayButtonComponent {
	@Input() public translations: any;

	public readonly styles = styles;

	constructor(
		public vbrickPlayer: VBrickPlayerComponent
	) { }

	public toggleChapterImage(): void {
		this.vbrickPlayer.chapterHelper.setShowChapterImage(!this.vbrickPlayer.chapterHelper.showChapterImage);
	}

}


